import * as Sentry from '@sentry/react';
import type { RequestConfig } from 'umi';

import { Integrations } from '@sentry/tracing';
import { Spin, message } from 'jst-components';
import 'jst-components/dist/jst-components.less';
import queryString from 'query-string';

import Cookies from '@/utils/cookie';

import { SILENT_PORTS, SILENT_PORTS_ON_LIMIT } from './constants';
import { logout } from './utils';
import getLogger from './utils/logger';

const coid: any = parseInt(Cookies.get('u_co_id') || '0', 10);
const coname: any = Cookies.get('u_co_name') || '';
const uid: any = parseInt(Cookies.get('u_id') || '0', 10);
const uname: any = Cookies.get('u_name') || '';

// sentry埋点
if (UMI_ENV === 'pre' || UMI_ENV === 'prod') {
  Sentry.init({
    dsn: 'https://d2a54d4ed5524f0983834450eb9a1e9d@sentry.erp321.com/58',
    autoSessionTracking: true,
    integrations: [new Integrations.BrowserTracing()],
    sendClientReports: false,
    environment: UMI_ENV || 'prod',
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
    ],
    tracesSampler: (samplingContext: any) => {
      // Examine provided context data (including parent decision, if any) along
      // with anything in the global namespace to compute the sample rate or
      // sampling decision for this transaction
      const { transactionContext } = samplingContext;
      // 过滤用户页面路由数据
      if (transactionContext.op === 'navigation') {
        return 0.1;
      }

      return 1.0;
    },
    beforeSend(event: any) {
      // 用于过滤敏感信息
      return event;
    },
  });
  Sentry.setTag('user.name', uname);
  Sentry.setTag('user.coname', coname);
  Sentry.setTag('user.uid', uid);
  Sentry.setTag('user.coid', coid);
}
/** 获取用户信息比较慢的时候会展示一个 loading */
export const initialStateConfig = {
  loading: <Spin spinning={true}>loading</Spin>,
};

export function getInitialState() {
  return {};
}

const getPrefix = () => {
  var refExpJUSHUITAN = /^http(s)?:\/\/\S*?jushuitan\.\S+$/;
  var isTestERP321CN = /^https?:\/\/test-\S+?\.erp321\.cn\S*$/i;
  var isDevERP321CN = /^https?:\/\/\S+?erp321\.cn\S*$/i;
  if (UMI_ENV === 'prod' && refExpJUSHUITAN.test(location.href)) {
    return '//api.jushuitan.com';
  } else if (UMI_ENV === 'pre' && refExpJUSHUITAN.test(location.href)) {
    return '//pre-api.jushuitan.com';
  } else if (UMI_ENV === 'test' && isTestERP321CN.test(location.href)) {
    return '//test-api.erp321.cn';
  } else if (UMI_ENV === 'dev' && isDevERP321CN.test(location.href)) {
    return '//dev-api.erp321.cn';
  } else {
    //@ts-ignore
    return APIPREFIX;
  }
};

export const request: RequestConfig = {
  prefix: getPrefix(),
  credentials: 'include', //允许后端设置cookie
  errorConfig: {
    adaptor: (res: any, opts: any) => {
      let { data, code, msg, ...rest } = res;
      let { url } = opts?.req || {};

      if (code !== 0) {
        if (SILENT_PORTS.find((port) => url.indexOf(port) > -1) !== undefined) {
          return res;
        }
        /** 触发了 epaas 限流 */
        if (
          code === SILENT_PORTS_ON_LIMIT.code &&
          SILENT_PORTS_ON_LIMIT.ports.find((port) => url.indexOf(port) > -1) !==
            undefined
        ) {
          return res;
        }
        if (msg === undefined || msg === '') {
          msg = '出错啦,请重试!';
        }

        if (code === -1) {
          logout();
          return;
        }

        message.error(msg);
      }

      return res;
    },
  },
  // 请求拦截
  requestInterceptors: [
    function (url: any, options: any) {
      const { showLoading = false } = options || {};
      const search = queryString.parse(window.location.search);
      if (search?._erpToken && search?.env === 'gyl') {
        options.headers = {
          ...options.headers,
          Authorization: search._erpToken,
          u_sso_token: search._erpToken,
        };
        options.credentials = 'omit';
      }
      // 是否展示Loading
      if (showLoading) {
        message.config({
          top: 80,
        });
        window.Msgloading = message.loading('');
      }

      if ((options?.data || {}).loading != undefined) {
        delete options.data.loading;
      }
      if (options && options?.data && typeof options?.data === 'object') {
        options.data.uid = uid;
        options.data.coid = coid;
      }

      return {
        url,
        options,
      };
    },
  ],

  responseInterceptors: [
    function (response: any) {
      try {
        if (window.Msgloading) {
          window.Msgloading();
          window.Msgloading = null;
        }
      } catch (error) {}

      return response;
    },
  ],
};

// 初始化埋点日志上报实例
window.__epaas_logger = getLogger(coid, uid, UMI_ENV === 'prod');
